import { OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { AuthService } from '../../services/auth/auth.service';
import { SearchService } from '../../services/search/search.service';
import { ReturnUrlService } from '../../services/return-url/return-url.service';
import { SitesService } from '../../services/sites/sites.service';
import { FlashMessagesService } from '../../services/flash-messages/flash-messages.service';
import { WindowService } from '../../services/window/window.service';
var GpsSearchComponent = /** @class */ (function () {
    function GpsSearchComponent(activatedRoute, authService, router, returnUrlService, searchService, sitesService, flashMessagesService, windowService) {
        var _this = this;
        this.activatedRoute = activatedRoute;
        this.authService = authService;
        this.router = router;
        this.returnUrlService = returnUrlService;
        this.searchService = searchService;
        this.sitesService = sitesService;
        this.flashMessagesService = flashMessagesService;
        this.windowService = windowService;
        this.messageIds = {
            httpError: null
        };
        this.searchService.latitude = Number(this.windowService.localStorage.getItem('latitudeSearchValue'));
        this.searchService.longitude = Number(this.windowService.localStorage.getItem('longitudeSearchValue'));
        this.userSub = this.authService.userInfoSubject.pipe(filter(function (user) { return !!user; }), take(1)).subscribe(function () {
            console.log('GpsSearchComponent: User info received, processing route parameters...');
            _this.processRouteParameters();
        });
        this.returnUrlService.save();
    }
    Object.defineProperty(GpsSearchComponent.prototype, "canSearch", {
        // --- Public Getters ---
        get: function () {
            return !this.selectSiteEnabled || this.searchService.site != null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GpsSearchComponent.prototype, "selectSiteEnabled", {
        get: function () {
            // Ensure userInfo exists before accessing its properties
            return !!this.authService.userInfo && this.authService.userInfo.isInRole('jjr');
        },
        enumerable: true,
        configurable: true
    });
    // --- Lifecycle Hooks ---
    GpsSearchComponent.prototype.ngOnDestroy = function () {
        this.searchService.clearAll();
        // Unsubscribe to prevent memory leaks
        if (this.userSub) {
            this.userSub.unsubscribe();
        }
        if (this.routeSub) {
            this.routeSub.unsubscribe();
        }
        if (this.querySub) {
            this.querySub.unsubscribe();
        }
    };
    // --- Public Methods ---
    GpsSearchComponent.prototype.search = function () {
        var _this = this;
        this.windowService.localStorage.setItem('latitudeSearchValue', this.searchService.latitude.toString());
        this.windowService.localStorage.setItem('longitudeSearchValue', this.searchService.longitude.toString());
        var commands = ['gps-search'];
        if (this.searchService.site) {
            commands.push(this.searchService.site.siteNumber);
        }
        var extras = { queryParams: {} };
        if (this.searchService.latitude) {
            extras.queryParams.latitude = this.searchService.latitude;
        }
        if (this.searchService.longitude) {
            extras.queryParams.longitude = this.searchService.longitude;
        }
        this.savedLatitude = this.windowService.localStorage.getItem('latitudeSearchValue');
        this.savedLongitude = this.windowService.localStorage.getItem('longitudeSearchValue');
        this.router.navigate(commands, extras).then(function (success) {
            _this.searchService.search(null, Number(_this.savedLatitude), Number(_this.savedLongitude));
            _this.returnUrlService.save();
        });
    };
    GpsSearchComponent.prototype.selectSite = function (site) {
        this.searchService.selectSite(site);
        this.searchService.latitude = null;
        this.searchService.longitude = null;
    };
    // --- Private Methods ---
    // Moved route processing logic into a separate method
    GpsSearchComponent.prototype.processRouteParameters = function () {
        var _this = this;
        // TODO: Replace explicit calls to search() and searchService.search() with combination of observables.
        // Routing to the same component doesn't recreate the component so we must subscribe to queryParams changes.
        this.routeSub = this.activatedRoute.params.subscribe(function (params) {
            var siteParam = params['site'];
            if (siteParam) {
                _this.sitesService.get(siteParam).subscribe(function (result) {
                    _this.searchService.site = result;
                    _this.searchService.search(null, _this.searchService.latitude, _this.searchService.longitude);
                }, function (error) {
                    _this.messageIds.httpError = _this.flashMessagesService.addMessageFor(error);
                });
            }
            else {
                _this.searchService.search(null, _this.searchService.latitude, _this.searchService.longitude);
            }
        });
        this.querySub = this.activatedRoute.queryParams.subscribe(function (queryParams) {
            var latNew = parseFloat(queryParams['latitude']);
            var lonNew = parseFloat(queryParams['longitude']);
            // Only search if params actually change *and* are valid numbers
            if ((latNew !== _this.searchService.latitude) ||
                (lonNew !== _this.searchService.longitude)) {
                console.log('GpsSearchComponent: Query params changed, triggering search.');
                _this.searchService.latitude = latNew;
                _this.searchService.longitude = lonNew;
                _this.searchService.search(null, _this.searchService.latitude, _this.searchService.longitude);
            }
        });
        // Initial snapshot check can likely be removed as subscriptions handle it,
        // but keep if direct navigation with all params needs immediate search.
        // const site = this.activatedRoute.snapshot.paramMap.get('site');
        // const latitude = this.activatedRoute.snapshot.queryParamMap.get('latitude');
        // const longitude = this.activatedRoute.snapshot.queryParamMap.get('longitude');
        // if (site && latitude && longitude) { ... search ... }
    };
    return GpsSearchComponent;
}());
export { GpsSearchComponent };
